<template>
    <div class="bg-white px-3 index" style="margin: 0 26px;margin-bottom: 0!important;">
        <div>
            <div class="add_tits" ref="titles">
                <el-form :inline="true" class="form-inlines u-f u-jsb">
                    <div>
                        <el-form-item label="医生:">
                            <el-select v-model="docname" placeholder="请选择" size="small" filterable clearable>
                                <el-option v-for="item in  doc_options" :key="item.id" :label="item.nickname"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="时间:">
                            <el-date-picker v-model="timeValue" type="daterange" range-separator="至" size="small"
                                :clearable="false" value-format="yyyy-MM-dd" start-placeholder="开始日期"
                                end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="星级:" class="u-f u-ac">
                            <el-select v-model="startValue" size="small" clearable placeholder="请选择">
                                <el-option v-for="item in 5" :key="item" :label="item+'星'" :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" size="small" @click="search">搜索</el-button>
                        </el-form-item>
                    </div>
                    <div>
                        <el-form-item>
                            <el-button size="small" icon="el-icon-circle-plus-outline" @click="add" type="primary">新增
                            </el-button>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <div class="ibox-content">
                <el-table :data="tableData" border style="width: 100%" v-loading="loadings" :height="height"
                    ref="configurationTable">
                    <el-table-column prop="create_time" label="日期" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="patient_name" label="用户姓名" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="patient_name" label="虚拟用户" show-overflow-tooltip width="55" align="center">
                        <template slot-scope="{row}">
                            <el-tag>{{({1:'是',2:'否'})[row.is_fictitious_user]}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="doc_name" label="医生姓名" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="create_author" label="星级" show-overflow-tooltip>
                        <template slot-scope="{row}">
                            <el-rate v-model="row.level" :colors="colors" disabled>
                            </el-rate>
                        </template>
                    </el-table-column>
                    <el-table-column prop="comment" label="评价内容" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="comment_tag" label="评价标签" show-overflow-tooltip></el-table-column>
                    <el-table-column label="操作" width="150">
                        <template slot-scope="scope">
                            <el-button @click="handleClick(scope.row)" type="primary" size="mini">编辑</el-button>
                            <el-button @click="delClick(scope.row)" type="warning" size="mini">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="u-f u-ac u-jsb ft_mr">
                    <div></div>
                    <div>
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                            :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                            layout="total, sizes, prev, pager, next, jumper" :total="count">
                        </el-pagination>
                    </div>
                </div>
            </div>

            <el-dialog title="新增" :visible.sync="dialogVisible" top='100px' width="40%">
                <div class="dialog-ibox-content">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                        <el-form-item label="医生:" prop="docname">
                            <el-select v-model="ruleForm.docname" :disabled='eid!=""' placeholder="请选择" size="small"
                                filterable clearable>
                                <el-option v-for="item in  doc_options" :key="item.id" :label="item.nickname"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="虚拟用户：" prop="yh">
                            <el-select v-model="ruleForm.yh" placeholder="请选择" size="small" filterable v-if="eid==''"
                                @change="selectUser(ruleForm.yh)">
                                <el-option v-for="item in yh_options" :key="item.id" :label="item.username"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                            <div v-else>
                                {{ruleForm.yh_name}}
                            </div>
                        </el-form-item>
                        <el-form-item label="星星：" required>
                            <el-rate v-model="ruleForm.rating" :colors="colors"></el-rate>
                        </el-form-item>
                        <el-form-item label="评论：" prop="reply_content">
                            <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="ruleForm.reply_content">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="评论标签：" prop="tags">
                            <el-select v-model="ruleForm.tags" multiple size="small" placeholder="请选择">
                                <el-option v-for="item in tag_options" :key="item.value" :label="item.label"
                                    :value="item.label">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false" size='small'>取 消</el-button>
                    <el-button @click="subForm('ruleForm')" size='small' :loading='subloading' type="primary">提交
                    </el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                loadings: false,
                timeValue: [],
                tableData: [],
                dialogVisible: false,
                ruleForm: {
                    docname: '',
                    yh: '',
                    rating: 5,
                    reply_content: '',
                    tags: [],
                    yh_name: ''
                },
                tag_options: [{
                        value: 1,
                        label: '给了咨询建议'
                    },
                    {
                        value: 2,
                        label: '经验丰富'
                    },
                    {
                        value: 3,
                        label: '热情亲切'
                    },
                    {
                        value: 4,
                        label: '耐心细致'
                    },
                    {
                        value: 5,
                        label: '回复神速'
                    },
                ],
                rules: {
                    docname: [{
                        required: true,
                        message: '请选择医生',
                        trigger: 'blur'
                    }],
                    reply_content: [{
                        required: true,
                        message: '请填写评论',
                        trigger: 'blur'
                    }],
                    tags: [{
                        required: true,
                        message: '请选择标签',
                        trigger: 'blur'
                    }],
                    yh: [{
                        required: true,
                        message: '请选择虚拟用户',
                        trigger: 'blur'
                    }],

                },
                eid: '',
                height: null,
                searchValue: '',
                startValue: '',
                colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
                currentPage: 1,
                pagesize: 15,
                count: 0,
                docname: '',
                doc_options: [],
                yh_options: [],
                selectUserdata: '',
                subloading: false,
                is_fictitious_user:1
            }
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        created() {
            if (sessionStorage.getItem('xuniUsers')) {
                this.yh_options = JSON.parse(sessionStorage.getItem('xuniUsers'))
            } else {
                this.getxnUser()
            }
        },
        mounted() {
            let that = this;
            var titles = that.$refs.titles.offsetHeight
            that.height = window.innerHeight - titles - 200 + 'px'
            window.onresize = () => {
                var titles = that.$refs.titles.offsetHeight
                that.height = window.innerHeight - titles - 200 + 'px'
            }
            that.begin()
        },
        methods: {
            begin() {
                let that = this
                that.getdoc()
                that.gettime()
                that.search()
            },
            getdoc() {
                axios
                    .post("/admin/doctorAssistantList", {
                        type: 9
                    }, {
                        token: true
                    })
                    .then(response => {
                        this.doc_options = response.data.data
                    })
                    .catch(error => {})
            },
            getxnUser() {
                this.axios
                    .post(
                        "/admin/h5/fictitiousUsers", {
                            page: 1,
                            page_count: 3000
                        }, {
                            token: true
                        }
                    )
                    .then((res) => {
                        this.yh_options = res.data.data.list
                        sessionStorage.setItem('xuniUsers', JSON.stringify(res.data.data.list))
                    })
                    .catch((err) => {

                    });
            },
            selectUser(val) {
                this.yh_options.forEach(e => {
                    if (e.id == val) {
                        this.selectUserdata = e
                    }
                })
            },
            gettime() {
                let that = this;
                let nowDate = new Date(new Date().getTime())
                let year = nowDate.getFullYear();
                let month = nowDate.getMonth() + 1;
                let day = nowDate.getDate();
                month = month > 9 ? month : '0' + month
                day = day > 9 ? day : '0' + day
                // that.timeValue = [
                //     year + "-" + month + "-01",
                //     year + "-" + month + "-" + day
                // ];
                that.timeValue = [
                    '2021-08-04',
                    '2022-02-26'
                ];
            },
            //查询
            search() {
                let that = this
                that.loadings = true
                that.tableData = [];
                axios.defaults.headers.common["token"] = this.user.token;
                axios.post("/admin/pc/doctorEvaluation/list", {
                        start_time: that.timeValue[0] ? that.timeValue[0] : '',
                        end_time: that.timeValue[1] ? that.timeValue[1] : '',
                        level: this.startValue,
                        doc_id: this.docname,
                        page: this.currentPage,
                        page_count: this.pagesize,
                    })
                    .then(response => {
                        that.loadings = false
                        that.tableData = response.data.data.list
                        that.count = response.data.data.count
                        this.$refs.configurationTable.$el.style.width = '99.99%'
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            //添加
            add() {
                let that = this
                this.eid = ''
                that.dialogVisible = true
                that.ruleForm = {
                    docname: '',
                    yh: '',
                    rating: 5,
                    reply_content: '',
                    tags: []
                }
            },
            //提交
            subForm(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        axios.defaults.headers.common["token"] = this.user.token;
                        let urls
                        let params = {}
                        this.subloading = true
                        if (this.eid == '') {
                            urls = '/admin/pc/doctorEvaluation/fictitiousSave'
                            params = {
                                doc_id: this.ruleForm.docname,
                                patient_id: this.selectUserdata.id,
                                patient_name: this.selectUserdata.username,
                                patient_avatar: this.selectUserdata.avatar,
                                comment: this.ruleForm.reply_content,
                                level: this.ruleForm.rating,
                                comment_tag: this.ruleForm.tags.join(' '),
                            }
                        } else {
                            urls = '/admin/pc/doctorEvaluation/fictitiousUpdate'
                            params = {
                                id:that.eid,
                                doc_id: this.ruleForm.docname,
                                comment: this.ruleForm.reply_content,
                                level: this.ruleForm.rating,
                                comment_tag: this.ruleForm.tags.join(' '),
                                is_fictitious_user:this.is_fictitious_user,

                            }
                        }
                        axios.post(urls, params)
                            .then(response => {
                                this.subloading = false
                                if (response.data.code == 200) {
                                    that.dialogVisible = false
                                    this.$message({
                                        showClose: true,
                                        type: 'success',
                                        message: response.data.msg
                                    });
                                    that.search()
                                } else {
                                    this.$message({
                                        showClose: true,
                                        message: response.data.msg,
                                        type: 'error'
                                    });
                                }
                            })
                            .catch(error => {
                                this.subloading = false
                            })
                    } else {
                        that.$alert('信息遗漏未填')
                        return false;
                    }
                });
            },

            //编辑
            handleClick(row) {
                let that = this
                that.eid = row.id
                that.dialogVisible = true
                that.ruleForm.docname = row.doc_id
                that.is_fictitious_user = row.is_fictitious_user
                that.ruleForm.yh_name = row.patient_name
                that.ruleForm.yh = row.patient_id
                that.ruleForm.rating = row.level
                that.ruleForm.reply_content = row.comment
                that.ruleForm.tags = row.comment_tag.split(' ')
            },
            delClick(r) {
                this.$confirm('此操作将永久删除该评论, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios.post('/admin/pc/doctorEvaluation/fictitiousDel', {
                            id: r.id
                        })
                        .then(response => {
                            if (response.data.code == 200) {
                                this.$message({
                                    showClose: true,
                                    type: 'success',
                                    message: response.data.msg
                                });
                                this.search()
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: response.data.msg,
                                    type: 'error'
                                });
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            }


        },
    }
</script>

<style lang="scss" scoped>
 .index{
        border-radius: 6px;
        padding-bottom: 10px;
    }
</style>